import Error404 from 'view/error/404.phtml'
import Error403 from 'view/default/login'

import RouterList from 'router';
import ModelList from 'model';
import Storage from 'storage';
import { openDatabase } from 'db/migrate';
import * as repo from 'db/repositories';
import { persistModel } from 'db/persist';
import SyncManager from 'sync/SyncManager';
import RealtimeService from 'sync/RealtimeService';

var app = _.extend( {

	// Gestion des router/controller
	router: {},
	setRouter: function( name, router ) { router.name = name; return this.router[name] = router },
	getRouter: function( name ) { return this.router[name] },


	// Gestion des données
	store: {},
	setStore: function( name, store ) { return this.store[name] = store },
	getStore: function( name ) { return this.store[name] },

	storage: Storage,
	db: repo,
	persistModel: persistModel,

	// Stores encore restaurés depuis fichier JSON (petits / auth)
	memoryStores: [ 'settings', 'user', 'data' ],

	initialize: function( config )
	{
		// enregistrement de la configuration
		this.config = config;

		_.each( RouterList, function( Router, name ) { app.setRouter( name, new Router ); } );
		_.each( ModelList, function( Store, name ) { app.setStore( name, new Store ); } );

		var restore = [];
		var nb = 0;
		var n = 0;

		// Dexie d'abord (migration JSON → tables)
		var dbReady = $.Deferred();
		openDatabase().then( function()
		{
			dbReady.resolve();
		} ).catch( function( err )
		{
			console.error( 'openDatabase', err );
			dbReady.resolve();
		} );
		restore.push( dbReady );

		_.each( app.store, function( store, name )
		{
			if( !_.result( store, 'file', false ) )
			{
				return;
			}

			// Listes volumineuses : plus de restore/persist JSON (source = Dexie)
			if( !_.contains( app.memoryStores, name ) )
			{
				return;
			}

			nb++;
			$('.pgr-text').text( '('+n+'/'+nb+')' );

			store.on( 'change sync add remove destroy create update reset', _.debounce( function()
			{
				console.warn( 'Store', name, 'persist' );
				store.persist();
			}, 1000 ) );

			var deferred = $.Deferred();

			store.restore().always(function()
			{
				n++;
				$('.pgr-text').text( '('+n+'/'+nb+')' );
				deferred.resolve();
			});

			restore.push(deferred);
		});

		return $.when.apply( this, restore ).always( app.ready );
	},

	migrateAuthToken: function()
	{
		var user = this.getStore('user');
		var settings = this.getStore('settings');

		if( user.has('token') && !settings.hasToken() )
		{
			settings.setToken( user.get('token') );
		}

		if( user.has('token') )
		{
			user.unset('token');
		}
	},

	ready: function()
	{
		app.migrateAuthToken();

		app.set( 'online', app.getStore('network').isOnline() );
		app.set( 'authenticated', app.getStore('settings').isAuthenticated() );
		app.set( 'geolocated', app.getStore('geolocation').isLocated() );

		_.each( app.memoryStores, function( name )
		{
			try {
				var store = app.getStore( name );
				if( store )
				{
					app.store.settings.setModifiedSince( store );
				}
			} catch(e) {}
		});

		app.set( 'ready', true );

		Backbone.history.start();

		app.setupTriggers();

		// Après restore user : purge dump bulk puis sync
		var startSync = function()
		{
			app.requestSync( { reason: 'startup' } ).always( function()
			{
				RealtimeService.start();
			} );
		};

		repo.ensureMineSyncMode().then( startSync ).catch( function( err )
		{
			console.error( 'ensureMineSyncMode', err );
			startSync();
		} );
	},


	view: null,

	unloadView: function()
	{
		app.trigger('unload');

		if( this.view )
		{
			console.log( 'unloadView', this.view );

			this.view.unload();
			this.view.remove();
			delete this.view;
		}

		$('.modal').remove();
		$('.modal-backdrop').remove();
		$('body').removeClass('modal-open');
		$("#app-wrapper").html('');
	},

	history: ['default/index'],
	render: function( view, lock )
	{
		this.unloadView();

		if( view instanceof Backbone.View )
		{
			view.setElement( $('<div/>').appendTo('#app-wrapper') );
			view.listenTo( view, 'render', function() { console.log( 'app.render', view ); } );
			view.render();
			this.view = view;
		}
		else
		{
			console.log( 'app.render', view.length );
			$("#app-wrapper").html( view );
		}

		this.set( 'locked', !!lock );

		var hash = Backbone.history.getHash();
		$("#historyBack").toggleClass( 'd-none', !hash.length || hash == 'default/index' );

		$('html,body').animate({ scrollTop: 0 }, 0);
		$("#app-header").css({ top: 0 });
	},

	redirect: function( url )
	{
		console.log( 'app.redirect', url )
		app.unloadView();
		document.location.hash = '#'+url+'?'+(new Date()).getTime()
	},

	reload: function()
	{
		var hash = Backbone.history.getHash().replace( /\?.*$/, '' );
		console.log( 'app.reload', hash );
		app.unloadView();
		document.location.hash = '#'+hash+'?'+(new Date()).getTime()
	},

	goBack: function()
	{
		var back, hash = Backbone.history.getHash();

		do { back = app.history.pop(); }
		while( back && hash == back );

		return Backbone.history.navigate( back || 'default/index', true );
	},

	error403: function()
	{
		console.warn( 'error', 403 )
		this.redirect( new Error403({
			model: app.getStore('user')
		}))
	},

	error404: function()
	{
		console.warn( 'error', 404 )
		this.render( Error404(), 'default/index' )
	},

	signout: function()
	{
		var userUuid = this.getStore( 'user' ).get( 'uuid' );

		this.getStore( 'settings' ).clearToken();
		this.getStore( 'user' ).update( this.getStore( 'user' ).defaults() );
		this.getStore( 'user' ).validationError = null;

		// Purge données privées + curseurs since_*_UUID
		if( userUuid )
		{
			repo.purgeUnpublished( userUuid ).then( function()
			{
				return repo.clearUserSince( userUuid );
			} ).then( function()
			{
				app.trigger( 'synched' );
			} ).catch( function( err )
			{
				console.error( 'signout purge', err );
			} );
		}
	},

	signin: function( data, message )
	{
		if( data && data.token )
		{
			this._authSyncMessage = message || null;
			this.getStore('settings').setToken( data.token );
			return this._lastAuthSync || $.Deferred().resolve();
		}

		return $.Deferred().resolve();
	},

	setupTriggers: function()
	{
		this.listenTo( this.getStore('network'), 'change', function() {
			this.set('online', this.getStore('network').isOnline() );
		});

		this.listenTo( this.getStore('settings'), 'change:token change', function() {
			this.set( 'authenticated', this.getStore('settings').isAuthenticated() );
		});

		this.listenTo( this.getStore('geolocation'), 'change', function() {
			this.set('geolocated', this.getStore('geolocation').isLocated() );
		});

		this.listenTo( this, 'authenticated', function( ok )
		{
			if( ok )
			{
				this.addMessage( 'Vous êtes connecté', 'success' );
				this.requestSync( { reason: 'auth' } );
			}
			else
			{
				this.addMessage( 'Vous êtes déconnecté', 'warning' );
			}
			RealtimeService.onAuthChanged();
		} );

		this.listenTo( this, 'online', function( online )
		{
			if( online )
			{
				this.addMessage( 'Vous avez retrouvé du réseau', 'info' );
				this.requestSync( { reason: 'network' } ).always( function()
				{
					RealtimeService.start();
				} );
			}
			else
			{
				this.addMessage( 'Vous êtes hors réseau !', 'warning' );
				RealtimeService.stop();
			}
		} );

		// PWA / onglet : reconnecte au retour visible
		document.addEventListener( 'visibilitychange', function()
		{
			if( document.visibilityState === 'visible' && app.is( 'ready' ) && app.is( 'online' ) )
			{
				RealtimeService.resume();
			}
			else if( document.visibilityState === 'hidden' )
			{
				RealtimeService.pause();
			}
		} );
	},

	commit: _.debounce(function( options )
	{
		options = _.extend( { reason: 'commit', delay: 500 }, options || {} );
		this.trigger( 'commit', options );
		return this.requestSync( options );
	}, 500, { leading: false } ),

	requestSync: function( options )
	{
		options = _.extend( { reason: 'commit', message: null, delay: null }, options || {} );

		if( options.delay === null )
		{
			options.delay = options.reason === 'commit' ? 500 : 0;
		}

		if( !this._syncDeferred )
		{
			this._syncDeferred = $.Deferred();
			this._syncDeferred.promise().always( function()
			{
				app._syncDeferred = null;
				app._syncMessage = null;
			} );
		}

		if( options.message )
		{
			this._syncMessage = options.message;
		}

		clearTimeout( this._syncDebounceTimer );
		this._syncDebounceTimer = setTimeout( _.bind( function()
		{
			var deferred = this._syncDeferred;
			var msg = this._syncMessage;

			this.sync( msg ).done( function()
			{
				deferred.resolve();
			} ).fail( function()
			{
				deferred.reject();
			} );
		}, this ), options.delay );

		return this._syncDeferred.promise();
	},

	addMessage: function( str, deferred, delay )
	{
		deferred = deferred || 'success';

		var msg = $( '<div/>', { class: 'p-2 text-light border-top border-light'} ).html( str );
		var icon = $( '<span/>', { class: 'mr-1' } ).prependTo( msg );

		var t = {
			success: { c: 'bg-info', i: 'far fa-check' },
			warning: { c: 'bg-warning', i: 'far fa-exclamation-triangle' },
			notice: { c: 'bg-warning', i: 'far fa-exclamation-triangle' },
			danger: { c: 'bg-danger', i: 'fas fa-exclamation-circle' },
			error: { c: 'bg-danger', i: 'fas fa-exclamation-circle' },
			info: { c: 'bg-info', i: 'far fa-info-circle' }
		}
		var fadeout = ( delay || 5 ) * 1000;

		if( _.isString( deferred ) )
		{
			icon.addClass( t[deferred] ? t[deferred].i : 'fa-bell' );
			msg.addClass( t[deferred] ? t[deferred].c : 'bg-dark' );
			msg.stop().fadeOut( fadeout, function() { msg.remove() } );
		}
		else
		{
			icon.html('<i class="fa fa-spinner fa-spin"></i>')
			msg.addClass('bg-secondary');

			deferred.done(function()
			{
				msg.removeClass('bg-secondary').addClass(t['success'].c);
				icon.html( '<i class="fa '+t['success'].i+'"></i>' );
			});
			deferred.fail(function()
			{
				msg.removeClass('bg-secondary').addClass(t['error'].c);
				icon.html( '<i class="fa '+t['error'].i+'"></i>' );
			});
			deferred.always( function()
			{
				msg.stop().fadeOut( fadeout, function() { msg.remove() } );
			});
		}

		app.trigger( 'message', msg );
		return msg
	},
	flash: function( msg ) { return this.addMessage( msg, 'success' ); },

	progress: [],
	addProgress: function( xhr )
	{
		var pgr = { id: _.uniqueId('pgr_'), loaded: 0, total: 0, steps: [], done: null, url: xhr.responseURL };
		app.progress.push( pgr );

		var cb = function( done, evt )
		{
			if( evt.lengthComputable )
			{
				pgr.steps.push({ size: evt.loaded, time: evt.timeStamp });
				pgr.loaded = evt.loaded;
				pgr.total = evt.total;
			}
			pgr.done = done;

			if( !_.some( _.pluck( app.progress, 'done' ), _.isNull ) )
			{
				app.progress.splice( 0, app.progress.length );
			}

			var stats = _.reduce( app.progress, function( memo, p )
			{
				memo.total += p.total;
				memo.loaded += p.loaded;
				memo.todo++;
				memo.done+= p.done ? 1 : 0;
				return memo;
			}, { total: 0, loaded: 0, todo: 0, done: 0 } );

			stats.percent = ( stats.loaded < stats.total ) ? 100 * stats.loaded / stats.total : null;
			stats.text = stats.todo ? stats.done + '/' + stats.todo : '';
			if( stats.todo && stats.percent ) stats.text+= ' (' + stats.percent.toFixed(0) + '%)';

			$('.pgr-text').text( stats.text );
			app.trigger( 'progress', app.progress, stats );
		};

		xhr.onprogress = xhr.upload.onprogress = _.partial( cb, null );
		xhr.onloadstart = xhr.upload.onloadstart = _.partial( cb, null );
		xhr.onloadend = xhr.upload.onloadend = _.partial( cb, true );
		xhr.onabort = xhr.upload.onabort  = _.partial( cb, false );
		xhr.onerror = xhr.upload.onerror = _.partial( cb, false );
		xhr.ontimeout = xhr.upload.ontimeout = _.partial( cb, false );
	},

	status: {
		ready: false,
		online: false,
		authenticated: false,
		geolocated: false,
		locked: false,
		working: false,
		synching: false,
		geolocating: false,
		moved: false
	},

	is: function( status )
	{
		if( !_.has( this.status, status ) ) throw new Error( "Unknow status : "+status )
		return this.status[status];
	},
	not: function( status ) { return !this.is( status ); },
	set: function( status, bool )
	{
		bool = !!bool

		if( this.is( status ) != bool )
		{
			console.warn( 'app.'+status, bool );
			this.status[status] = bool;

			this.trigger( status+':'+String(bool) );
			this.trigger( status, bool );
			this.trigger( 'status', status, bool )
		}
		else
		{
			console.log( 'app.'+status, bool )
		}

		return this;
	},

	syncStores: [ 'data', 'zone_list', 'user', 'pond_list', 'visit_list', 'image_list' ],

	syncStoreLabels: {
		data: 'Chargement des métadonnées…',
		zone_list: 'Chargement des départements…',
		user: 'Chargement du profil…',
		pond_list: 'Chargement des mares…',
		visit_list: 'Chargement des visites…',
		image_list: 'Chargement des photos…',
	},

	sync: function( msg )
	{
		return SyncManager.sync( msg );
	},

	requestBackgroundSync: function()
	{
		if( !('serviceWorker' in navigator) || !('SyncManager' in window) ) return;

		navigator.serviceWorker.ready.then( function( reg )
		{
			return reg.sync.register( 'mares-sync' );
		}).then( function()
		{
			console.log( '[BackgroundSync] sync enregistré' );
		}).catch( function( err )
		{
			console.warn( '[BackgroundSync] échec de l\'enregistrement', err );
		});
	},

}, Backbone.Events );

export default app;
